import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

import { RootStackParamList } from '@/navigation/types';

/**
 * Navigation object of the root stack, for screens that need to act on it instead of their own
 * stack (resets, pops back to home). Assumes the caller is nested inside the root stack, the
 * parent is undefined when called from a root screen itself.
 */
export const useRootNavigation = () => useNavigation().getParent<NativeStackNavigationProp<RootStackParamList>>();
